import { Turtle } from "../../../../content/blog/2020/turtles-and-grammar-2020-07-15/components/Turtle";
import { TurtleControls } from "../../../../content/blog/2020/turtles-and-grammar-2020-07-15/components/TurtleControls";
import * as React from 'react';
export default {
  Turtle,
  TurtleControls,
  React
};